import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import LockIcon from "@mui/icons-material/LockOutlined";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { useAuthorizer } from "@navigations/Authorizer";
import type { Dispatch, SetStateAction } from "react";
import type { TPaperCandidateChallengeObjective } from "../../types";
import { CandidateObjectiveLoadingState } from "../index";

export interface IPaperCandidateObjectiveButtonDeleteProps<T extends TPaperCandidateChallengeObjective> {
  candidateObjective: T;
  onDelete: (candidateObjective: T) => void | Promise<void>;
  disabled?: boolean;
  loading: CandidateObjectiveLoadingState;
  setLoading: Dispatch<SetStateAction<CandidateObjectiveLoadingState>>;
}

export const PaperCandidateObjectiveButtonDelete = <T extends TPaperCandidateChallengeObjective>({
  candidateObjective,
  onDelete,
  disabled,
  loading,
  setLoading,
}: IPaperCandidateObjectiveButtonDeleteProps<T>) => {
  const authorized = useAuthorizer(["candidate.challenges.modify"]);
  const Icon = candidateObjective.createdFromCer ? LockIcon : DeleteIcon;

  const deleteCandidateObjective = async () => {
    setLoading(CandidateObjectiveLoadingState.DELETE);
    try {
      await onDelete(candidateObjective);
    } finally {
      setLoading(CandidateObjectiveLoadingState.NONE);
    }
  };

  return (
    <Tooltip
      title={
        candidateObjective.createdFromCer
          ? "Vous ne pouvez pas supprimer cet objectif car il est lié au CE en cours."
          : undefined
      }
    >
      <span>
        <IconButton
          color="primary"
          onClick={deleteCandidateObjective}
          disabled={
            !authorized ||
            disabled ||
            candidateObjective.createdFromCer ||
            loading !== CandidateObjectiveLoadingState.NONE
          }
        >
          {loading === CandidateObjectiveLoadingState.DELETE ? <CircularProgress size={24} /> : <Icon />}
        </IconButton>
      </span>
    </Tooltip>
  );
};
